import React, { useState, useEffect } from "react";
import { PageTitle } from "../../components";
import {
  Table,
  Space,
  Button,
  Form,
  Input,
  Select,
  Modal,
  Tabs,
  message,
  Skeleton,
  Result,
} from "antd";
import { db } from "../../firebase";
import {
  collection,
  doc,
  onSnapshot,
  getDocs,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import type { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";

import { Routes, Route, useParams, Link, useNavigate } from "react-router-dom";
import { CURRENT_CLUB_ID } from "../../_helpers/constants";
import { createAuditLog } from "../../_helpers/auditLog";

const { Option } = Select;
const { TabPane } = Tabs;

interface DataType {
  key?: string;
  lastName?: string;
  firstName?: string;
}

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

function Leader() {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [data, setData] = useState<DataType>({});
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(true);

  let { leaderId } = useParams();

  useEffect(() => {
    if (leaderId) {
      const unsub = onSnapshot(doc(db, "adminUsers", leaderId), (doc: any) => {
        const leaderData = doc.data();

        // Check if the leader belongs to the current club
        if (leaderData && leaderData.clubId === CURRENT_CLUB_ID && leaderData.role === "leader") {
          setData(leaderData);
          form.setFieldsValue(leaderData);
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }

        setLoading(false);
      });

      return unsub;
    }
  }, [leaderId]);

  const onFinish = () => {
    form
      .validateFields()
      .then((values) => {
        if (leaderId) {
          updateDoc(doc(db, "adminUsers", leaderId), values).then(() => {
            // Create audit log
            if (leaderId) {
              createAuditLog(
                "update",
                "leader",
                leaderId,
                `${values.lastName} ${values.firstName}`,
                values
              );
            }

            message.success("Амжилттай.");
          });
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  if (loading) {
    return (
      <>
        <PageTitle loading={true} title="Уншиж байна..." right={null} />
        <div className="page-content-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <Skeleton loading={true} active />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (!hasAccess) {
    return (
      <>
        <PageTitle title="Хандах эрхгүй" right={null} />
        <div className="page-content-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <Result
                      status="403"
                      title="Хандах эрхгүй"
                      subTitle="Уучлаарай, тэргүүлэгчийн мэдээлэл олдсонгүй."
                      extra={
                        <Button type="primary" onClick={() => navigate("/leaders")}>
                          Буцах
                        </Button>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {data ? (
        <PageTitle
          loading={loading}
          title={`${data?.lastName} ${data?.firstName}`}
          description={"Тэргүүлэгчийн профайл"}
          right={null}
          breadcrumbItems={[
            { link: "/leaders", title: "Тэргүүлэгчид" },
            { title: `${data?.lastName} ${data?.firstName}` },
          ]}
        />
      ) : (
        ""
      )}
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <Skeleton loading={loading} active>
                    <Form {...formItemLayout} form={form} onFinish={onFinish}>
                      <Form.Item
                        label="Имэйл хаяг"
                        name="email"
                        rules={[
                          { required: true, message: "Имэйл хаяг оруулна уу!" },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Овог"
                        name="lastName"
                        rules={[
                          { required: true, message: "Овог оруулна уу!" },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Нэр"
                        name="firstName"
                        rules={[{ required: true, message: "Нэр оруулна уу!" }]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Утасны дугаар"
                        name="phoneNumber"
                        rules={[
                          {
                            required: true,
                            message: "Утасны дугаар оруулна уу!",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                          Хадгалах
                        </Button>
                      </Form.Item>
                    </Form>
                  </Skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Leader;
